import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { AccountService } from './services/account.service';
import { LoaderService } from './services/loader.service';
import { UserService } from './services/user.service';
import { DbMasterService } from './services/db-master.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { LayoutComponent } from './components/layout/layout.component';
import { SharedModule } from '../shared/shared.module';
import { NextPage } from '@cvx/nextpage';
import { TopMenuComponent } from './components/top-menu/top-menu.component';


@NgModule({
  declarations: [BreadcrumbComponent, PageHeaderComponent, LayoutComponent, TopMenuComponent],
  imports: [
    NextPage,
    CommonModule,
    NzAvatarModule,
    NzBreadCrumbModule, 
    RouterModule,
    NzGridModule,
    SharedModule 
  ],
  providers: [
    AccountService,
    LoaderService,
    UserService,
    DbMasterService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  exports: [
    // Export it so it can be used in other modules  
    BreadcrumbComponent ,
    PageHeaderComponent,
    LayoutComponent 
  ],
})
export class CoreModule { }
